import { axleLoadConstants } from '../constants/axleLoadConstants';
import { authConstants } from '../constants/authConstants';

const createItem = (items, item) => {
  items.unshift(item);
  return items;
};
const updateItem = (items, item) => {
  const result = [];
  for (let i = 0; i < items.length; i++) {
    if (items[i].id !== item.id) {
      result.push(items[i]);
    } else {
      result.push(item);
    }
  }
  return result;
};
const initialState = {
  showFormModal: false,
  currentItem: {},
  meta: { per_page: 7, total: 0, current_page: 1 },
  items: []
};

export const axleLoads = (state = initialState, action) => {
  switch (action.type) {
    // Get page
    case axleLoadConstants.GET_PAGE_REQUEST:
      return {
        ...state,
        items: [],
        loading: true,
        error: ''
      };
    case axleLoadConstants.GET_PAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.axleLoads.data,
        meta: action.axleLoads.meta
      };
    case axleLoadConstants.GET_PAGE_FAILURE:
      return {
        // error: action.error.toString()
        ...state,
        loading: false,
        error: 'Не удалось загрузить список!'
      };

    // Get all
    case axleLoadConstants.GET_ALL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case axleLoadConstants.GET_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.axleLoads.data
      };
    case axleLoadConstants.GET_ALL_FAILURE:
      return {
        // error: action.error.toString()
        ...state,
        loading: false,
        error: 'Не удалось загрузить список!'
      };

    // Update
    case axleLoadConstants.UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: updateItem(state.items, action.axleLoad),
        showFormModal: false
      };

    case axleLoadConstants.DELETE_SUCCESS:
      // remove deleted HeaderMenu from state
      return {
        ...state,
        loading: false,
        items: state.items.filter(axleLoad => axleLoad.id !== action.id),
        meta: {
          ...state.meta,
          total: state.meta.total - 1
        }
      };
    case axleLoadConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to HeaderMenu
      return {
        ...state,
        loading: false,
        items: state.items.map(axleLoad => {
          if (axleLoad.id === action.id) {
            // make copy of HeaderMenu without 'deleting:true' property
            const { deleting, ...axleLoadCopy } = axleLoad;
            // return copy of HeaderMenu with 'deleteError:[error]' property
            return { ...axleLoadCopy, deleteError: action.error };
          }

          return axleLoad;
        })
      };

    // Get item
    case axleLoadConstants.LOAD_REQUEST:
      return {
        ...state,
        loading: true
      };
    case axleLoadConstants.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        currentItem: action.axleLoad.data
      };
    case axleLoadConstants.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Не удалось загрузить элемент!'
      };

    // form modal
    case axleLoadConstants.FORM_MODAL_OPEN:
      return {
        ...state,
        showFormModal: true
      };
    case axleLoadConstants.FORM_MODAL_CLOSE:
      return {
        ...state,
        showFormModal: false
      };
    case axleLoadConstants.SET_CURRENT_ITEM:
      return {
        ...state,
        currentItem: action.item
      };

    case authConstants.LOGOUT:
      return initialState;

    default:
      return state;
  }
};
